<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="none"
        viewBox="0 0 16 16"
        :aria-labelledby="props.ariaLabelledby"
        :aria-hidden="!props.ariaLabelledby"
        role="img"
    >
        <path fill="currentColor" d="m6.25 12-.717-.717 3.3-3.3-3.3-3.3.717-.716 4.017 4.016L6.25 12Z" />
    </svg>
</template>

<script setup lang="ts">
type ChevronRightIconProps = {
    ariaLabelledby?: string;
};

const props = defineProps<ChevronRightIconProps>();
</script>
